import { applyMiddleware, combineReducers, createStore } from 'redux';
import shoppingCart from './reducers/cart';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/index';
import banner from './reducers/banner';

export default function configureStore (initialState) {
    const reducers = {
        banner,
        shoppingCart
    };

    const rootReducer = combineReducers(reducers);

    const middlewareEnhancer = applyMiddleware(thunk);
    const composedEnhancers = composeWithDevTools(middlewareEnhancer);

    return createStore(rootReducer, initialState, composedEnhancers);
};


